import { useEditor } from "features/editor/Feature";

import { useScopedPersistedState } from "./usePersistedState";

export const useAutoOpenPreview = () => {
  const project = useEditor();

  return useScopedPersistedState(
    "CSB_AUTO_OPEN_PREVIEW",
    true,
    project.type === "branch"
      ? `${project.owner}/${project.repo}`
      : `${project.alias}`,
  );
};
